import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/index.md';
import Alerts from '../resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "adobe-campaign-classic"
    }}>{`Adobe Campaign Classic`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <h2 {...{
      "id": "configure-campaign-classic-extension-in-the-data-collection-ui"
    }}>{`Configure Campaign Classic extension in the Data Collection UI`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In the Data Collection UI, select the `}<strong parentName="p">{`Extensions`}</strong>{` tab.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the `}<strong parentName="p">{`Catalog`}</strong>{` tab, locate the `}<strong parentName="p">{`Adobe Campaign Classic`}</strong>{` extension, and select `}<strong parentName="p">{`Install`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Type in the settings for your extension.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<strong parentName="p">{`Save`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Complete the publishing process to update the SDK configuration.`}</p>
        <p parentName="li">{`For more information about publishing, see the `}<a parentName="p" {...{
            "href": "https://experienceleague.adobe.com/docs/launch/using/publish/overview.html"
          }}>{`publishing overview`}</a>{`.`}</p>
      </li>
    </ol>
    <h3 {...{
      "id": "configure-campaign-classic-extension"
    }}>{`Configure Campaign Classic extension`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "37.8125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/5530d/configure.webp 320w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/0c8fb/configure.webp 640w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/94b1e/configure.webp 1280w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/0b34d/configure.webp 1920w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/d5269/configure.webp 2560w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/a18f3/configure.webp 3154w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/dd4a7/configure.png 320w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/0f09e/configure.png 640w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/bbbf7/configure.png 1280w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/ac7a9/configure.png 1920w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/c7a69/configure.png 2560w", "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/0d3f6/configure.png 3154w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/previous-versions/static/9f62f43ace172ed037bee7b862936806/bbbf7/configure.png",
            "alt": "Configuring the Campaign Classic extension",
            "title": "Configuring the Campaign Classic extension",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You can retrieve your Campaign Classic registration or tracking endpoint URLs in the Campaign Classic interface under the `}<strong parentName="p">{`Tools > Advanced > Deployment wizard`}</strong>{` menu. The endpoint for push notifications is usually the same as the URL that is used for web forms and surveys.`}</p>
    <h4 {...{
      "id": "registration-endpoints"
    }}>{`Registration endpoints`}</h4>
    <p>{`Type the registration endpoint URL(s) for your Campaign Classic instances. You can specify up to three unique endpoints for your development, staging, and production environments.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`For this extension, the registration endpoint URLs should be entered `}<strong parentName="p">{`without`}</strong>{` a prefixing `}<inlineCode parentName="p">{`https://.`}</inlineCode></p>
    <h4 {...{
      "id": "tracking-endpoints"
    }}>{`Tracking endpoints`}</h4>
    <p>{`Type the tracking endpoint URL(s) for your Campaign Classic instances. Like the registration URLs, you can specify up to three unique endpoints for your development, staging, and production environments.`}</p>
    <InlineAlert variant="warning" slots="text" mdxType="InlineAlert" />
    <p>{`For this extension, the tracking endpoint URLs should be entered `}<strong parentName="p">{`without`}</strong>{` a prefixing `}<inlineCode parentName="p">{`https://.`}</inlineCode></p>
    <h4 {...{
      "id": "integration-key-ios"
    }}>{`Integration key (iOS)`}</h4>
    <p>{`You can specify up to three unique iOS integration keys for your development, staging, and production environments. iOS integration keys are generated after creating a service that contains iOS applications using the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/campaign-classic/using/installing-campaign-classic/connect-to-campaign/installing-the-client-console.html"
      }}>{`Campaign Classic client console`}</a>{`. For more information on where to find the integration key, see the tutorial on `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/campaign-classic/using/sending-messages/sending-push-notifications/configure-the-mobile-app/configuring-the-mobile-application.html"
      }}>{`configuring the mobile application in Adobe Campaign`}</a>{`.`}</p>
    <h4 {...{
      "id": "integration-key-android"
    }}>{`Integration key (Android)`}</h4>
    <p>{`You can specify up to three unique Android integration keys for your development, staging, and production environments. Android integration keys are generated after creating a service that contains Android applications using the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/campaign-classic/using/installing-campaign-classic/connect-to-campaign/installing-the-client-console.html"
      }}>{`Campaign Classic client console`}</a>{`. For more information on where to find the integration key, see the tutorial on `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/campaign-classic/using/sending-messages/sending-push-notifications/configure-the-mobile-app/configuring-the-mobile-application-android.html"
      }}>{`configuring the mobile application in Adobe Campaign`}</a>{`.`}</p>
    <h4 {...{
      "id": "request-timeout"
    }}>{`Request timeout`}</h4>
    <p>{`The request timeout is the amount of time, in seconds, to wait for a response from the registration or tracking endpoint before timing out. The SDK default timeout value is 30 seconds.`}</p>
    <h2 {...{
      "id": "add-campaign-classic-to-your-app"
    }}>{`Add Campaign Classic to your app`}</h2>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=add" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=add" mdxType="Tabs" />
    <h3 {...{
      "id": "register-campaign-classic-with-mobile-core"
    }}>{`Register Campaign Classic with Mobile Core`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=register" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=register" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      